import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { config } from '@app/core/app-config';
import { UserPermissionsService } from '@app/core/user-permissions/user-permissions.service';
import { ListingsFacade } from '@app/listings';
import { PropertiesFacade } from '@app/shared/+state/properties';
import { NoteType } from '@app/shared/components/note/note.interface';
import { ChannelListing, ListingReview, LoadingState, UpdatePropertyOption } from '@app/shared/interfaces';
import { Observable, Subscription } from 'rxjs';
import { SignupWizardService } from '../signup-wizard.service';

enum ReviewListingsStage {
  ReviewListings = 'ReviewListings',
  ConfirmListings = 'ConfirmListings',
}

@Component({
  standalone: false,
  selector: 'sbnb-signup-review-listings',
  templateUrl: './signup-review-listings.component.html',
  styleUrls: ['./signup-review-listings.component.scss'],
})
export class SignupReviewListingsComponent implements OnInit, OnDestroy {
  platform: string;
  channelUserId: string;
  platformString: string; // Friendly platform name
  perms$ = this.userPermissionsService;

  tabNames = {
    hosted: 'Hosted listings',
    cohosted: '⚠️ Co-hosted listings',
    archived: '⚠️ Archived listings',
  };

  pageLoadingState$: Observable<LoadingState>;
  listingReviewsSubscription$: Subscription;
  listingReviews: ListingReview | null;
  LoadingState = LoadingState;
  NoteType = NoteType;
  UpdatePropertyOption = UpdatePropertyOption;
  reviewListingsStage = ReviewListingsStage.ReviewListings;
  ReviewListingsStage = ReviewListingsStage;
  bulkMuteAndUnMutePropertiesLoadingState$: Observable<LoadingState>;

  nextStepLoading = false;

  constructor(
    public wizard: SignupWizardService,
    private readonly userPermissionsService: UserPermissionsService,
    private listingsFacade: ListingsFacade,
    private propertiesFacade: PropertiesFacade,
    private router: Router
  ) { }

  ngOnDestroy(): void {
    if (this.listingReviewsSubscription$ && this.listingReviewsSubscription$.unsubscribe) {
      this.listingReviewsSubscription$.unsubscribe();
    }
  }

  ngOnInit(): void {
    this.platform = 'airbnb-official';
    this.platformString = 'Airbnb';
    this.channelUserId = this.wizard.getAirbnbChannelUserId();
    this.listingReviewsSubscription$ = this.listingsFacade.listingReviews$.subscribe(
      (reviews) => (this.listingReviews = reviews)
    );
    this.listingsFacade.loadListingReviews(this.platform, this.channelUserId, false, {
      url: `${config.API_URL}/signup/channels/${this.platform}/${this.channelUserId}/listings`,
      headers: this.wizard.setTokenHeader(),
    });
    this.pageLoadingState$ = this.listingsFacade.listingReviewsLoadingState$;
    this.bulkMuteAndUnMutePropertiesLoadingState$ = this.propertiesFacade.bulkMuteAndUnMutePropertiesLoadingState$;
  }

  mute(listing: ChannelListing) {
    const index = this.findListingReviewIndexById(listing.listing_id);
    index !== undefined
      ? (this.listingReviews.listings[index] = {
        ...this.listingReviews.listings[index],
        ...{
          muted: true,
        },
      })
      : null;
  }

  unmute(listing: ChannelListing) {
    const index = this.findListingReviewIndexById(listing.listing_id);
    index !== undefined ? (this.listingReviews.listings[index].muted = false) : null;
  }

  continue() {
    this.nextStepLoading = true;

    this.wizard.goToStep(9).subscribe(
      () => {
        this.nextStepLoading = false;
        this.router.navigateByUrl('/user/register/done');
      },
      () => {
        this.nextStepLoading = false;
      }
    );

    //  Mute/Unmute is currently out of scope for signup flow
    // const mute = [];
    // const unmute = [];
    // if (this.listingReviews && this.listingReviews.listings) {
    //   for (let i = 0; i < this.listingReviews.listings.length; i++) {
    //     const listing = this.listingReviews.listings[i];
    //     listing.muted ? mute.push(listing.property_id) : unmute.push(listing.property_id);
    //   }
    // }

    // this.propertiesFacade.bulkMuteAndUnMuteProperties(mute, unmute, {
    //   url: `${config.API_URL}/signup/properties/mute`,
    //   headers: this.wizard.setTokenHeader(),
    // });

    // this.bulkMuteAndUnMutePropertiesLoadingState$.subscribe((loadingState) => {
    //   if (loadingState === LoadingState.Success) {
    //     this.wizard.goToStep(9).subscribe((res) => {
    //       this.router.navigateByUrl('/user/register/done');
    //     });
    //   }
    // });
  }

  findListingReviewIndexById(id) {
    let index;

    if (this.listingReviews && this.listingReviews.listings) {
      for (let i = 0; i < this.listingReviews.listings.length; i++) {
        if (this.listingReviews.listings[i].listing_id === id) {
          index = i;
        }
      }
    }
    return index;
  }
}
